import _ from "lodash";
import { ColDef, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { formatMessage } from "lib/globalize-util";
import { IRowData } from "../types";
import { Editors } from "constants/product-collection";
import { formatDateRange } from "./formatDate";
import { isSameRange } from "helpers/delivery-windows/compare-dates";
import { toDeliveryWindow } from "helpers/legacy-cart/delivery-windows";
import { SizingViewComponents } from "constants/sizingView";

interface IOptions {
    width?: number;
    pinnedFooterRowRenderer?: string;
    collapseCurrentYear?: boolean;
}

export const buildShipmentColDef = ({
    width,
    pinnedFooterRowRenderer,
    collapseCurrentYear = false,
}: IOptions = {}): ColDef => {
    return {
        headerName: formatMessage("Delivery"),
        colId: "shipment",
        filter: false,
        suppressMenu: true,
        suppressColumnsToolPanel: true,
        suppressMovable: true,
        editable: false,
        cellClass: "shipment",
        pinned: "left",
        width: width > 0 ? width : 178,
        suppressCellFlash: true,
        cellRendererSelector: (params: CastProp<ICellRendererParams, "data", IRowData>) => {
            if (params.node.rowPinned === "bottom") {
                return {
                    component: pinnedFooterRowRenderer || Editors.PinnedFooterModalRowRenderer,
                };
            }
            if (params.data?.dbpPrices) {
                return {
                    component: SizingViewComponents.DbpDeliveryCellRenderer,
                };
            }
        },
        valueGetter: ({ data }: CastProp<ValueGetterParams, "data", IRowData>): string => {
            if (!data?.splitFields) {
                return "";
            }
            const {
                splitFields: { shipStart, shipEnd },
            } = data;
            const deliveryWindow = _.find(
                data.availability?.[data.warehouse?.id]?.[data.productId]?.deliveryWindows,
                (dw) => isSameRange(toDeliveryWindow(dw), { start: shipStart, end: shipEnd })
            );
            return (
                (deliveryWindow?.adjustableDates === false && deliveryWindow.displayName) ||
                formatDateRange(shipStart, shipEnd, { collapseCurrentYear })
            );
        },
    };
};
